<template>
  <div style="height:70vh;padding: 10px">
    <Form :model="searchData" inline @submit.native.prevent="getData(1)" :label-width="100">
    </Form>
    <!-- 充值 -->
    <Modal v-model="recharge_modal" title="充值">
      <!-- <div style="font-size: 16px;padding-top:20px;">
          <div>&nbsp;&nbsp;&nbsp;&nbsp;请扫码支付充值并且上传支付凭证（支付截图）</div>
        </div>
      <div class="pay-wrapper" style="display:flex;flex-flow: wrap;">
        <div  style="font-size: 16px">
          <img :src="this.path + wechat_img" />
          <div>微信</div>
        </div>
        <div  style="text-align:center;font-size: 16px">
          <img :src="this.path + alipay_img" />
          <div>支付宝</div>
        </div>
        <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
            <img :src="path + item.url">
            <div class="demo-upload-list-cover">
                <span style="font-size:12px;">{{item.name}}</span>
                <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
            </div>
          </div>
        <div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            type="drag"
            action=""
            style="margin-left:20px; display: inline-block;width:100px;height:100px;">
            <div style="width: 100px;height:110px;">
              <Icon style="color:#000;" type="ios-cloud-upload-outline" size="80"></Icon>
            </div>
        </Upload>
        </div>
        </div> -->
      <div>充值方式：
        <RadioGroup v-model="paytype">
          <Radio border label="wechat">微信</Radio>
          <Radio border label="alipay">支付宝</Radio>
        </RadioGroup>
      </div>
      <div class="recharge-num">
        <div>充值金额（元）：<Input type="number" placeholder="请输入已充值金额" style="width:60%;margin:20px 0;"
            v-model="recharge_value" /></div>
        <div>充值积分：{{ integral.rmb_to_integral * recharge_value }}积分(1元={{ integral.rmb_to_integral }}积分)</div>
      </div>
      <div class="footer" slot="footer">
        <Button type="primary" @click="rechargeSub">提交</Button>
      </div>
    </Modal>
    <Modal v-model="recharge_pop">
      <div class="pay-wrapper">
        <div style="font-size: 16px">
          <p>订单号：{{ order_sn }}</p>
          <img style="width:300px;height:300px" :src="path + pay_img" />
          <div v-if="paytype == 'wechat'">微信</div>
          <div v-else>支付宝</div>
        </div>
      </div>
      <div class="footer" slot="footer">
        <Button type="text" @click="recharge_pop = false; getjifen(); getData(1)">关闭</Button>
      </div>
    </Modal>
    <!-- 提现 -->
    <Modal v-model="withdrawal_modal">
      <div class="withdrawal-num">
        <p>提现积分：
          <Input type="number" placeholder="提现金额" style="width:60%;margin:20px;" v-model="withdrawal_value" />
        </p>
        <div style="padding-left:30px;">{{ withdrawal_value }}积分(1元={{ integral.rmb_to_integral }}积分)<br>
          <!-- 现金会在三日内返回，请注意查收 -->
          <span style="color:red;font-size:.8vw">现金会在三日内返回，请注意查收</span><br>
          <span style="color:red;font-size:.8vw">提现需先上传微信收款码或支付宝收款码</span>
        </div>
      </div>
      <div class="footer" slot="footer">
        <Button type="primary" @click="withdrawalSub">提现</Button>
      </div>
    </Modal>
    <Col :span="12">
    <Row>
      <Col :span="8" style="font-size: 16px">充值积分:&nbsp;{{ jifenobj.recharge_integral }}</Col>
      <Col :span="8" style="font-size: 16px">赠送积分:&nbsp;{{ jifenobj.given_integral }}</Col>
      <Col :span="8"><Button type="primary" @click="recharge">充值</Button> <Button type="primary"
        @click="withdrawal">提现</Button></Col>
    </Row>
    </Col>
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin: 20px 0">
      <template slot-scope="{ row }" slot="remain">
        {{ row.before - row.after > 0 ? '-' + row.remain : row.remain }}
      </template>
      <template slot-scope="{ row }" slot="type">
        {{ row.type == 1 ? '充值积分' : '赠送积分' }}
      </template>
    </Table>
    <Page style="text-align: right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  import { mapState } from "vuex";
  import ImageCompressor from "image-compressor.js";
  export default {
    computed: {
      ...mapState({
        userInfo(state) {
          return state.user.userInfo;
        },
      }),

    },
    data() {
      return {
        jifenobj: {},
        imgName: "",
        pay_img: '',
        order_sn: '',
        alipay_img: '',
        wechat_img: '',
        visible: false,
        recharge_pop: false,
        uploadList: [],
        integral: {},
        paytype: 'wechat',
        recharge_modal: false,
        recharge_value: "",
        withdrawal_modal: false,
        withdrawal_value: "",
        types: {
          11: "后台赠送",
          12: "后台扣除",
          21: "后台充值",
          22: "后台扣除",
          3: "免费使用系统扣分",
          24: "提现扣除积分",
          25: "提现驳回积分",
          4: "购买资源扣除",
          5: "报名考试扣除",
          6: "学生充值",
        },
        searchData: {},
        tableColumns: [
          {
            title: "排序",
            key: "id",
            align: "center",
            render: (h, params) => {
              // console.log(params);
              return h("div", (this.tableData.current_page - 1) * 10 + (params.index + 1));
            },
          },
          { title: "记录id", key: "id", align: "center" },
          { title: "时间", key: "create_time", align: "center" },
          { title: "积分变化", slot: "remain", align: "center" },
          { title: "积分类型", slot: "type", align: "center" },
          { title: "简介", key: "info", align: "center" },
        ],
        indexUrl: "/app/integral_log/index",
      };
    },
    mixins: [indexPage],
    mounted() {
      this.getIntegral();
      this.getjifen();

      // this.uploadList = this.$refs.upload.fileList;
    },
    methods: {
      getjifen() {
        this.$axios
          .get("/app/user/getIntegral")
          .then((res) => {
            if (res.code == 1) {
              this.jifenobj = res.data;
            }
          })
      },
      // 获取积分配置
      getIntegral() {
        this.$axios.get("/app/setting/getIntegral").then((res) => {
          if (res.code == 1) {
            this.integral = res.data;
          }
        });
      },
      // 充值确认
      rechargeSub() {
        // let num = document.querySelector(".recharge-num input").value;
        // // 目前列表内逻辑是单个凭证，所以先保留单对象数组
        // let payment_img = this.uploadList[0] ? this.uploadList[0].url : "";
        let data = {
          money: this.recharge_value,
          type: this.paytype == 'wechat' ? 1 : this.paytype == 'alipay' ? 2 : null,
          // payment_img: payment_img,
        };
        console.log(data)
        // if (!this.recharge_value || !payment_img) {
        //   return this.$Message.warning("请填写支付凭证图和已充值金额")
        // }
        this.$axios.post("/app/recharge/recharge", data).then((res) => {
          if (res.code == 1) {
            this.rechargepop(this.paytype, res.data.order_sn)
            // this.$Message.success(res.msg || res.data);
          } else {
            this.$Message.warning(res.msg || res.data);
          }
        });
      },
      rechargepop(paytype, order_sn) {
        let data = {
          order_sn: order_sn,
          func: 'scan',
          type: paytype
        };
        this.$axios.post("/app/qtpay/pay", data).then((res) => {
          if (res.code == 1) {
            this.pay_img = res.data.code_url
            // this.$Message.success('已生成订单'+order_sn);
            this.order_sn = order_sn;
            this.recharge_pop = true;
            this.recharge_modal = false;
          } else {
            this.$Message.warning(res.msg || res.data);
          }
        });
      },
      // 提现确认
      withdrawalSub() {
        let num = document.querySelector(".withdrawal-num input").value;
        // console.log(document.querySelector(".withdrawal-num input"));
        let data = {
          integral: num,
        };
        this.$axios.post("/app/withdraw/withdraw", data).then((res) => {
          if (res.code == 1) {
            this.$Message.success(res.data);
            this.withdrawal_modal = false;
            this.getjifen()
            this.getData(this.tableData.current_page)
          } else {
            this.$Message.warning(res.msg);
          }
        });
      },
      // 充值
      recharge() {
        // this.$axios.get('/app/setting/getPay').then(res => {
        //   this.wechat_img = res.data.wechat_img
        //   this.alipay_img = res.data.alipay_img
        // })
        this.paytype = 'wechat'
        this.recharge_value = 0
        this.recharge_modal = true;
      },
      // 提现
      withdrawal() {
        this.withdrawal_modal = true;
      },
      handleView(name) {
        this.imgName = name;
        this.visible = true;
      },
      handleRemove(index) {
        // 从 upload 实例删除数据
        this.uploadList = []
      },
      beforeUpload(file) {
        let _th = this;
        new ImageCompressor(file, {
          quality: 0.3,
          success(res) {
            res = new File([res], res.name, {
              type: res.type,
              lastModified: Date.now(),
            });
            _th.upLoad(1, res);
          },
        });
      },
      upLoad(eve, file) {
        let formData = new FormData();
        formData.append("file", file);
        this.$axios.postUp("/app/tool/uploadImage", formData).then((res) => {
          if (res.code == 1) {
            this.uploadList = [];
            this.uploadList.push({ url: res.data, name: file.name });
          } else {
          }
        });
        return false;
      },
    },
  };
</script>
<style scoped lang="less">
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
  .pay-wrapper {
    padding-top: 40px;
    // display: flex;
    text-align: center;
    img {
      width: 100px;
      height: 100px;
      margin-left: 20px;
    }
  }
  .withdrawal-num {
    border: 0px;
  }
  /deep/ .ivu-modal {
    width: 600px !important;
  }
</style>
